import React from "react";
import { HERO_IMAGE } from "../lib/site";
import { WhatsAppButton, WhatsAppIcon } from "./WhatsApp";

export default function Hero() {
  return (
    <section id="top" className="relative w-full bg-white overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-14 pt-32 pb-12 md:pt-40 md:pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Left — type */}
          <div className="lg:col-span-7 order-2 lg:order-1">
            <h1
              data-testid="hero-headline"
              className="serif text-[44px] leading-[1.02] sm:text-[64px] md:text-[80px] lg:text-[96px] text-[#111] font-light"
            >
              One Dress.
              <br />
              <span className="italic font-light">Six Silhouettes.</span>
              <br />
              <span className="block mt-2 text-[28px] sm:text-[40px] md:text-[48px] lg:text-[56px] tracking-wider-elegant uppercase font-light">
                Only three
              </span>
              <span className="block text-[28px] sm:text-[40px] md:text-[48px] lg:text-[56px] tracking-wider-elegant uppercase font-light">
                in the world.
              </span>
            </h1>

            <p
              data-testid="hero-subhead"
              className="mt-10 max-w-[480px] sans text-[16px] leading-[1.8] text-[#111]/90"
            >
              Effortless, limited edition versatile wear designed by{" "}
              <span className="serif italic">Chanel Rapallini</span>. Handcrafted in
              signature viscose, fluid, weightless, ready to travel.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <WhatsAppButton testId="hero-cta-whatsapp">
                View Current Prints on WhatsApp
              </WhatsAppButton>

              <a
                href="#looks"
                data-testid="hero-secondary-cta"
                className="inline-flex items-center gap-2 text-[12px] sans tracking-luxe text-[#111] underline-hover"
              >
                Explore the Six
                <span aria-hidden>↓</span>
              </a>
            </div>

            <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 gap-5 sm:gap-6 max-w-[540px] border-t border-[var(--line)] pt-6">
              <div>
                <div className="text-[11px] sans tracking-luxe text-[#111]/75">Edition</div>
                <div className="serif italic text-[18px] mt-1 text-[#111]">Three per print</div>
              </div>
              <div>
                <div className="text-[11px] sans tracking-luxe text-[#111]/75">Silhouettes</div>
                <div className="serif italic text-[18px] mt-1 text-[#111]">Worn six ways</div>
              </div>
              <div>
                <div className="text-[11px] sans tracking-luxe text-[#111]/75">Material</div>
                <div className="serif italic text-[18px] mt-1 text-[#111]">Signature viscose</div>
              </div>
              <div>
                <div className="text-[11px] sans tracking-luxe text-[#111]/75">Made</div>
                <div className="serif italic text-[18px] mt-1 text-[#111]">By hand</div>
              </div>
              <div>
                <div className="text-[11px] sans tracking-luxe text-[#111]/75">Sizing</div>
                <div className="serif italic text-[18px] mt-1 text-[#111]">XXS to XXL</div>
              </div>
              <div>
                <div className="text-[11px] sans tracking-luxe text-[#111]/75">Fit</div>
                <div className="serif italic text-[18px] mt-1 text-[#111]">Maternity friendly</div>
              </div>
            </div>
          </div>

          {/* Right — image */}
          <div className="lg:col-span-5 order-1 lg:order-2">
            <div className="relative aspect-[4/5] w-full overflow-hidden bg-[var(--bone)]">
              <img
                src={HERO_IMAGE}
                alt="The Magic Dress in motion"
                className="absolute inset-0 w-full h-full object-cover kenburns"
                style={{ objectPosition: "0% 30%" }}
                loading="eager"
              />
              <div className="absolute bottom-5 left-5 right-5 flex items-center justify-between text-white">
                <span className="serif italic text-[15px]">Chanel Rapallini</span>
                <span className="text-[11px] sans tracking-luxe">London</span>
              </div>
            </div>
            <div className="hidden lg:flex items-center gap-3 mt-5 text-[12px] sans tracking-luxe text-[#111]/80">
              <WhatsAppIcon className="w-4 h-4 text-[#25d366]" />
              <span>Reply within the hour, London time</span>
            </div>
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="border-y border-[var(--line)] py-5 overflow-hidden">
        <div className="marquee-track flex gap-14 whitespace-nowrap text-[12px] sans tracking-luxe text-[#111]/80">
          {Array.from({ length: 2 }).map((_, k) => (
            <div key={k} className="flex gap-14 shrink-0">
              <span>· Limited to three pieces per print</span>
              <span>· Hand-finished viscose</span>
              <span>· Designed in London</span>
              <span>· Worn six ways</span>
              <span>· Maternity friendly</span>
              <span>· XXS to XXL</span>
              <span>· Curated brochure on WhatsApp</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
